import React from 'react';
import _ from 'lodash';
import is from 'is_js';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { Controller, useFormContext } from 'react-hook-form';

const FormSelect = ({ id, label, disabled, fullWidth, variant, options }) => {
  const {
    control,
    formState: { errors },
    isRequired,
  } = useFormContext();

  const required = isRequired(id);

  return (
    <FormControl
      disabled={disabled}
      error={is.truthy(errors[id])}
      fullWidth={fullWidth}
    >
      <Controller
        name={id}
        control={control}
        render={({ field }) => {
          const fieldParams = {
            ...field,
            value: field.value ? field.value : '',
          };
          return (
            <>
              <InputLabel id={`${id}-label`} required={required}>
                {label}
              </InputLabel>
              <Select
                {...fieldParams}
                labelId={`${id}-select`}
                required={required}
                variant={variant}
              >
                {options.map(({ text, value }) => (
                  <MenuItem key={value} value={value}>
                    {text}
                  </MenuItem>
                ))}
              </Select>
            </>
          );
        }}
      />
      <FormHelperText>{_.get(errors[id], 'message')}</FormHelperText>
    </FormControl>
  );
};

FormSelect.defaultProps = {
  label: '',
  autoFocus: false,
  disabled: false,
  fullWidth: false,
  variant: 'standard',
};

FormSelect.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  variant: PropTypes.string,
};

export default FormSelect;
